import React, { useEffect, useState } from 'react';
import api from '../api';
import { useNavigate } from 'react-router-dom';
import BackButton from '../components/BackButton';

export default function CompanySettingsPage() {
  const [form, setForm] = useState({
    BusinessName: '',
    Address: '',
    GSTIN: '',
    PANNumber: '',
    Phone: '',
    Email: '',
    BankName: '',
    AccountNumber: '',
    IFSCCode: '',
    LogoPath: ''
  });

  const [message, setMessage] = useState('');
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  const fetchSettings = async () => {
    try {
      const res = await api.get('/settings/get');
      if (res.data) {
        setForm({
          BusinessName: res.data.BusinessName || '',
          Address: res.data.Address || '',
          GSTIN: res.data.GSTIN || '',
          PANNumber: res.data.PANNumber || '',
          Phone: res.data.Phone || '',
          Email: res.data.Email || '',
          BankName: res.data.BankName || '',
          AccountNumber: res.data.AccountNumber || '',
          IFSCCode: res.data.IFSCCode || '',
          LogoPath: res.data.LogoPath || ''
        });
      }
    } catch (err) {
      console.error('Error loading settings:', err);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage('');
    try {
      await api.post('/settings/update', form);
      setMessage('✅ Settings saved successfully.');
    } catch (err) {
      console.error(err);
      setMessage('❌ Error saving settings.');
    }
    setSaving(false);
  };

  // Modern glass card style
  const cardStyle = {
    background: 'rgba(255,255,255,0.97)',
    borderRadius: '2.5rem',
    boxShadow: '0 8px 48px 0 rgba(40, 110, 250, 0.10)',
    backdropFilter: 'blur(9px)',
    border: '1.5px solid rgba(180,210,255,0.18)',
    margin: '0 auto',
    maxWidth: 750
  };

  return (
    <div
      className="min-vh-100 py-5"
      style={{
        background: 'linear-gradient(120deg, #b3d8fc 0%, #e8f1ff 100%)',
        minHeight: '100vh',
      }}
    >
      <div className="container" style={{ maxWidth: 800 }}>
        <div className="d-flex align-items-center my-3">
          <BackButton />
          <h3 className="ms-2 mb-0 fw-bold" style={{ letterSpacing: 1, color: '#2654a2' }}>Company Settings</h3>
        </div>
        <div className="card shadow-lg rounded-5 p-4 border-0" style={cardStyle}>
          <form onSubmit={handleSubmit} className="row g-4">
            {/* Logo Preview */}
            <div className="col-12 text-center mb-2">
              {form.LogoPath ? (
                <img
                  src={form.LogoPath}
                  alt="Company Logo"
                  style={{
                    height: 64,
                    objectFit: 'contain',
                    borderRadius: 10,
                    border: '1px solid #e2e9f6',
                    background: '#f8fbff',
                    marginBottom: 4,
                    boxShadow: '0 2px 16px #dae6fa55'
                  }}
                />
              ) : (
                <span className="text-muted" style={{ fontSize: 13 }}>No Logo Uploaded</span>
              )}
            </div>
            {/* Business Name */}
            <div className="col-md-8">
              <label className="form-label fw-semibold">Business Name</label>
              <input type="text" className="form-control rounded-pill px-3 py-2" name="BusinessName" value={form.BusinessName} onChange={handleChange} required />
            </div>
            {/* Phone */}
            <div className="col-md-4">
              <label className="form-label fw-semibold">Phone</label>
              <input type="text" className="form-control rounded-pill px-3 py-2" name="Phone" value={form.Phone} onChange={handleChange} />
            </div>
            {/* Address */}
            <div className="col-12">
              <label className="form-label fw-semibold">Address</label>
              <textarea className="form-control rounded-4 px-3" name="Address" value={form.Address} onChange={handleChange} rows={2} />
            </div>
            {/* GST & PAN */}
            <div className="col-md-6">
              <label className="form-label fw-semibold">GSTIN</label>
              <input type="text" className="form-control rounded-pill px-3 py-2" name="GSTIN" value={form.GSTIN} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold">PAN Number <span className="text-secondary" style={{ fontSize: 12 }}>(optional)</span></label>
              <input type="text" className="form-control rounded-pill px-3 py-2" name="PANNumber" value={form.PANNumber} onChange={handleChange} placeholder="e.g. ABCDE1234F" />
            </div>
            {/* Email */}
            <div className="col-md-6">
              <label className="form-label fw-semibold">Email</label>
              <input type="email" className="form-control rounded-pill px-3 py-2" name="Email" value={form.Email} onChange={handleChange} />
            </div>
            {/* Bank Details */}
            <div className="col-md-6">
              <label className="form-label fw-semibold">Bank Name</label>
              <input type="text" className="form-control rounded-pill px-3 py-2" name="BankName" value={form.BankName} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold">Account Number</label>
              <input type="text" className="form-control rounded-pill px-3 py-2" name="AccountNumber" value={form.AccountNumber} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold">IFSC Code</label>
              <input type="text" className="form-control rounded-pill px-3 py-2" name="IFSCCode" value={form.IFSCCode} onChange={handleChange} />
            </div>
            {/* Logo URL */}
            <div className="col-12">
              <label className="form-label fw-semibold">Logo URL <span className="text-secondary" style={{ fontSize: 12 }}>(Paste full URL)</span></label>
              <input type="text" className="form-control rounded-pill px-3 py-2" name="LogoPath" value={form.LogoPath} onChange={handleChange} placeholder="https://yourdomain/uploads/logo.png" />
            </div>
            {/* Buttons */}
            <div className="col-12 d-flex align-items-center mt-2">
              <button className="btn btn-primary rounded-pill px-4 py-2 fw-semibold" type="submit" disabled={saving}>
                {saving ? 'Saving...' : 'Save Settings'}
              </button>
              <button className="btn btn-light ms-3 px-3 py-2 rounded-pill border" type="button" onClick={() => navigate(-1)}>
                Cancel
              </button>
              {message && <span className="ms-3 text-success fw-semibold">{message}</span>}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
